import { themeVariables } from "Components/theme";
import classNames from "classnames";
import noop from "lodash/noop";
import React, { memo, useMemo } from "react";
function Close(props) {
    const roundedClassName = props.btnRounded ? "border-rounded-circle" : "border-rounded-base";
    const iconStyle = useMemo(() => {
        var _a, _b;
        return ({
            ...(!props.btnMode ? props.style || {} : {}),
            border: props.btnMode
                ? `1px solid ${themeVariables[props.btnModeBorderColor || "gray-300"]}`
                : undefined,
            padding: props.btnMode ? props.btnModePadding : undefined,
            width: props.btnMode
                ? "auto"
                : props.size || props.fontSize
                    ? `${props.size || props.fontSize}px`
                    : (_a = props.style) === null || _a === void 0 ? void 0 : _a.width,
            height: props.btnMode
                ? "auto"
                : props.size || props.fontSize
                    ? `${props.size || props.fontSize}px`
                    : (_b = props.style) === null || _b === void 0 ? void 0 : _b.height,
            fontSize: props.fontSize ? `${props.fontSize}px` : undefined
        });
    }, [
        props.style,
        props.btnMode,
        props.fontSize,
        props.size,
        props.btnModeBorderColor,
        props.btnModePadding
    ]);
    const icon = (React.createElement("div", { className: classNames("dx-icon dx-icon-close flex-box-centered-content unselectable text-center", props.btnMode && "line-height-1", props.btnMode ? roundedClassName : props.className, props.disabled ? "opacity-0_6" : "clickable"), style: iconStyle, title: props.title, onClick: !props.disabled ? props.onClick : undefined }));
    return props.btnMode ? (React.createElement("div", { style: props.style, className: classNames(props.className, roundedClassName, "bg-white") }, icon)) : (icon);
}
export default memo(Close);
Close.defaultProps = {
    onClick: noop,
    btnMode: false,
    btnModePadding: 8,
    btnRounded: true,
    btnModeBorderColor: "gray-300",
    animateHoverColor: true,
    fontSize: 16,
    disabled: false,
    title: ""
};
